// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  flex-direction: column;
}

ng-select {
  width: 35%;
}

.second-level-menu {
  max-width: 280px;
  min-width: 280px;
}

#library-card-list {
  width: 100%;
  height: 150px;
  display: none;
  overflow-y: auto;
  scrollbar-width: none;
}
#library-card-list .notification-list {
  width: 100%;
}
#library-card-list .notification-list .card {
  width: 245px;
  background: #fff;
  border-radius: 10px;
  float: left;
  margin: 5px;
}
#library-card-list .notification-list .card .card-body {
  padding: 0.2rem 0.5rem;
}
#library-card-list .notification-list .card .card-body label {
  font-size: 0.9rem;
  color: #666;
}
#library-card-list .notification-list .card .icon {
  display: none;
}
#library-card-list .notification-list .card.active {
  background: var(--primarylightColor);
  color: #fff;
}
#library-card-list .notification-list .card.active .card-body label {
  color: var(--primaryColor);
}
#library-card-list .notification-list .card.active .icon {
  display: block;
}

@media screen and (max-width: 767px) {
  ng-select {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/ai-library/ai-library/ai-library.component.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;AACJ;;AACA;EACI,UAAA;AAEJ;;AAAA;EACI,gBAAA;EACA,gBAAA;AAGJ;;AAAA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;AAGJ;AAFI;EACI,WAAA;AAIR;AAFQ;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;AAIZ;AAHY;EACI,sBAAA;AAKhB;AAJgB;EACI,iBAAA;EACA,WAAA;AAMpB;AAHY;EACI,aAAA;AAKhB;AAHY;EACE,oCAAA;EACA,WAAA;AAKd;AAHgB;EACI,0BAAA;AAKpB;AAFc;EACE,cAAA;AAIhB;;AAKA;EACI;IACI,WAAA;EAFN;AACF","sourcesContent":[":host{\n    flex-direction: column;\n}\nng-select{\n    width:35%;\n}\n.second-level-menu{\n    max-width:280px;\n    min-width:280px;\n}\n\n#library-card-list{\n    width:100%;\n    height:150px;\n    display: none;\n    overflow-y:auto;\n    scrollbar-width: none;\n    .notification-list{\n        width:100%;\n       \n        .card{\n            width:245px;\n            background: #fff;\n            border-radius: 10px;\n            float: left;\n            margin: 5px;\n            .card-body{\n                padding:.2rem .5rem;\n                label{\n                    font-size:.9rem;\n                    color:#666;\n                }\n            }\n            .icon{\n                display: none;\n            }\n            &.active{\n              background: var(--primarylightColor);\n              color:#fff;\n              .card-body{\n                label{\n                    color:var(--primaryColor);\n                }\n             }\n              .icon{\n                display: block;\n             }\n            }\n         }\n    }\n\n\n}\n\n@media screen and (max-width:767px) {\n    ng-select{\n        width:100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
